export class ChangePassword {
	newPassword: string;
	oldPassword: string;
	userName: string;
	id: string;
}
